import { isChunkLoadError } from '@/shared/utils/lazyWithRetry';
import i18n from 'i18next';

interface AppErrorFallbackProps {
  error: unknown;
}

export function AppErrorFallback({ error }: Readonly<AppErrorFallbackProps>) {
  const heading = isChunkLoadError(error)
    ? i18n.t('newVersion.errorHeading')
    : i18n.t('common.error.generic');

  const errorMessage =
    error instanceof Error ? error.message : typeof error === 'string' ? error : 'Unknown error.';

  const stack = error instanceof Error ? error.stack : null;

  return (
    <div className="flex items-center justify-center min-h-screen bg-background p-4">
      <div className="w-full max-w-2xl flex flex-col gap-4 rounded-2xl border border-status-danger-border bg-status-danger-bg p-6">
        <h1 className="text-lg font-semibold text-status-danger-fg">{heading}</h1>
        <p className="text-sm text-status-danger-fg/80 whitespace-pre-wrap break-words">
          {errorMessage}
        </p>
        {stack && (
          <details className="text-body-xs text-status-danger-fg/60">
            <summary className="cursor-pointer">Stack trace</summary>
            <pre className="mt-2 whitespace-pre-wrap break-words overflow-x-auto">{stack}</pre>
          </details>
        )}
        <button
          type="button"
          onClick={() => globalThis.location.reload()}
          className="self-start rounded-full bg-status-danger px-4 py-1.5 text-sm font-medium text-primary-foreground hover:bg-status-danger/90"
        >
          {i18n.t('common.actions.reload')}
        </button>
      </div>
    </div>
  );
}
